import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/shared/Navbar/Navbar';
import Footer from '../components/shared/Footer/Footer';
import Loader from '../components/shared/Loader/Loader';
import ServiceUnavailable from '../components/shared/ServiceUnavailable/ServiceUnavailable';
import { useBackendHealth } from '../hooks/useBackendHealth';
import { useRouteTransitionLoader } from '../hooks/useRouteTransitionLoader';
import './PublicLayout.css';

const PublicLayout = () => {
  const { isChecking, isUnavailable } = useBackendHealth();
  const isTransitioning = useRouteTransitionLoader();
  const showLoader = isChecking || isTransitioning;

  if (isUnavailable) {
    return <ServiceUnavailable />;
  }

  return (
    <>
      {showLoader && <Loader />}
      <Navbar />
      <div className="public-layout__page">
        <Outlet />
      </div>
      <Footer />
    </>
  );
};

export default PublicLayout;
